import {NodeOrigin, XYPosition} from 'reactflow';

export interface TranslateNodeOriginArgs {
  sourceNodeOrigin: NodeOrigin;
  sourcePosition: XYPosition;
  targetNodeOrigin: NodeOrigin;
  nodeHeight: number;
  nodeWidth: number;
}

/**
 * Given a source and target origin, translate the given source position into a target position.
 *
 * @param sourceNodeOrigin - The origin point of the source position as [x, y] where values range from 0 to 1
 * @param sourcePosition - The source position coordinates
 * @param targetNodeOrigin - The desired origin point as [x, y] where values range from 0 to 1
 * @param nodeHeight - The height of the node in pixels
 * @param nodeWidth - The width of the node in pixels
 * @returns Object with x and y coordinates translated to the target origin
 */
export default function translateNodeOrigin({
  sourceNodeOrigin,
  sourcePosition,
  targetNodeOrigin,
  nodeHeight,
  nodeWidth,
}: TranslateNodeOriginArgs): XYPosition {
  const [sourceOriginX, sourceOriginY] = sourceNodeOrigin;
  const [targetOriginX, targetOriginY] = targetNodeOrigin;

  // Calculate offset by removing source origin effect and adding target origin effect
  const offsetX = (targetOriginX - sourceOriginX) * nodeWidth;
  const offsetY = (targetOriginY - sourceOriginY) * nodeHeight;

  return {
    x: sourcePosition.x + offsetX,
    y: sourcePosition.y + offsetY,
  };
}
